const PageHarViewer = (): Promise<unknown> =>
  import('@/features/har-viewer/pages/HarViewer.vue');

export default [
  {
    path: '/har-viewer/:panelId/:sessionId',
    component: PageHarViewer
  }
];
